module.exports = new __parcel__URL__("the-wall.75590785.jpg").toString();